import type { Url, Uuid } from '@shady-pines/types';
import { z } from 'zod';
import type { Model } from './model';

export const ZodHerokuUserIdSchema = z.string().brand('HerokuUserID');
export type HerokuUserId = z.infer<typeof ZodHerokuUserIdSchema>;

export type User = Model<{ id: Uuid<User> }>;

export const UserRole = ['dj', 'admin', 'listener'] as const;
export type UserRole = (typeof UserRole)[number];

export type UserName = string & {
  __userName: 'UserName';
};

export type Profile = Model<{
  id: Uuid<User>;
  heroku_user_id: HerokuUserId | null;
  name: string | null;
  profile_picture_url: Url | null;
  role: UserRole;
  user_name: UserName | null;
  device_type: string | null;
  app_version: `${number}.${number}.${number}` | null;
  shows_migrated: boolean | null;
  user_synced_after_sign_in: boolean | null;
}>;
